










































































// TODO: Enable lint.
/* eslint-disable */
import { defineComponent, reactive, SetupContext } from '@vue/composition-api';

import axios from 'axios';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type State = {
  file: File | null,
  filePreview: string,
  filename: string,
  message: string
}

export default defineComponent({
  name: "ItemUpload",
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/style.css' },
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/item.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" },
      { src: "/js/item.js" }
    ]
  },

  setup(_, context: SetupContext) {
    const defaultMessage = '複数の商品をアップロードしたい場合はZIP形式にしてアップロードしてください。'

    const state = reactive<State>({
      file: null,
      filePreview: '',
      filename: '',
      message: defaultMessage
    });

    function selectFile(e: Event) {
      const target = e.target as HTMLInputElement
      const files = target.files as FileList

      state.file = files[0];
      state.filename = (state.file as File).name;
      previewImage(files[0])
    }

    function previewImage(file: File) {
      const reader = new FileReader();
      reader.onload = (e: Event) => {
        state.filePreview = reader.result as string
      };
      reader.readAsDataURL(file);
    }

    async function upload(e: Event) {
      if (state.file === null) return;

      const options = {
        baseURL: `${(await API.endpoint('dev'))}`,
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        }
      };
      const api = axios.create(options);

      const data = new FormData();
      data.append("name", state.filename);
      data.append("image", state.file!, state.filename);

      api.post('/images/products', data).then(response => {
        console.log(response);
        context.root.$router.push('/item');
      }).catch(err => {
        console.log(err);
        state.message = "アップロードに失敗しました"
      });
    }

    return {
      state,
      selectFile,
      upload
    };
  }
});
